import React, { useState } from 'react'
import Chart from 'react-apexcharts'
import ApexCharts from 'apexcharts'
import { IDadosGraficosPesquisaModel } from '../helpers/AnaliseResultadoHelper'

type Props = {
  dadosGraficosPesquisa: IDadosGraficosPesquisaModel | undefined
}

const GraficoMediaPorDimensao = ({ dadosGraficosPesquisa }: Props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const baixarTodosGraficos = async (formato: 'png' | 'jpeg') => {
    if (!dadosGraficosPesquisa?.GraficoMediaPorDimensao) return

    for (let i = 0; i < dadosGraficosPesquisa.GraficoMediaPorDimensao.length; i++) {
      const id = `grafico-media-dimensao-${i}`
      try {
        const res: any = await ApexCharts.exec(id, 'dataURI')
        const link = document.createElement('a')
        link.href = res.imgURI
        link.download = `grafico_media_por_dimensao_${i + 1}.${formato}`
        link.click()
      } catch (e: unknown) {
        console.error(`Erro ao gerar imagem do gráfico ${id}:`, e)
      }
    }
  }

  return (
    <div className={`card mb-6 ${dadosGraficosPesquisa ? '' : 'd-none'}`}>
      <div className='card-header justify-content-between'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>
            Média por dimensão{' '}
            ({dadosGraficosPesquisa?.Escala.Inicio ?? 0} a {dadosGraficosPesquisa?.Escala.Fim ?? 10})
          </h3>
        </div>

        <div className='card-toolbar'>
          <div className='dropdown'>
            <button
              className='btn btn-light btn-sm dropdown-toggle'
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              ☰
            </button>
            <div
              className={`dropdown-menu dropdown-menu-end ${dropdownOpen ? 'show' : ''}`}
              style={{ minWidth: '160px' }}
            >
              <button className='dropdown-item' onClick={() => baixarTodosGraficos('png')}>
                Baixar PNG
              </button>
              <button className='dropdown-item' onClick={() => baixarTodosGraficos('jpeg')}>
                Baixar JPEG
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='card-body py-5'>
        <div className='row justify-content-center mt-4'>
          {dadosGraficosPesquisa?.GraficoMediaPorDimensao?.map((data, index) => {
            const options = {
              labels: data.Labels,
              series: data.Series,
              colors: data.Colors,
              chart: {
                id: `grafico-media-dimensao-${index}`
              },
              plotOptions: {
                radialBar: {
                  startAngle: -90,
                  endAngle: 90,
                  track: {
                    background: ['#f4f4f4'],
                    startAngle: -90,
                    endAngle: 90
                  },
                  dataLabels: {
                    name: {
                      show: true,
                      offsetY: -115
                    },
                    value: {
                      fontSize: '30px',
                      color: '#3e875f',
                      show: true,
                      offsetY: -30,
                      formatter: function (val: number) {
                        const escalaMaxima = dadosGraficosPesquisa.Escala.Fim ?? 10
                        const valorAjustado = ((val * escalaMaxima) / 100).toFixed(2)
                        return valorAjustado
                      }
                    }
                  }
                }
              }
            }

            return (
              <div key={`chart-media-por-dimensao-${index}`} className='col-lg-4'>
                <Chart
                  options={options}
                  series={options.series}
                  type='radialBar'
                  height={'320px'}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export { GraficoMediaPorDimensao }
